import { CarehomeDto } from './../../../dto/carehomedto'
import { UserDto, UserPermissionDto, MedRoundGroup, EMARResult } from "./../../../dto/Dtos";
import { PatientDto } from "./../../../dto/PatientDto";
import Dal from './../../../scripts/dataaccess'
import CarehomeHub from "./CarehomeHub"
import toastr from '../../../components/helpers/Toaster'
import moment from 'moment'

interface IPatientMar {
    Patient: PatientDto;
    MarData: EMARResult;
}

interface ITrackingMedRoundGroup {
    MedRoundGroup: MedRoundGroup;
    RecentlyChanged: boolean;
}

interface IPatientRound {
    Patient: PatientDto;
    IsActive: boolean;
    Nurse: string;
    Rounds: { [key: string]: ITrackingMedRoundGroup; };
    
    latestMARUser: string;
    latestMedAdminDateTime: Date;
}


export default class CarehomeDispensationController {
    private _carehomeId: string;
    private _marDate: Date;
    public CarehomeHub: CarehomeHub;

    public Patients: Array<PatientDto>;
    public Groups: Array<MedRoundGroup>;
    public PatientRounds: Array<IPatientRound>;
    public IsLoading: boolean;
    public CurrentGroupIndex: number;

    public constructor() {
        this.Patients = new Array<PatientDto>();
        this.Groups = new Array<MedRoundGroup>();
        this.PatientRounds = new Array<IPatientRound>();
        this.IsLoading = true;
        
        this.CarehomeHub = new CarehomeHub();

        this.CarehomeHub.OnStartedAdministration((c, p) => this.HandleServerEvent(c, p, "OnStartedAdministration"));
        this.CarehomeHub.OnStoppedAdministration((c, p) => this.HandleServerEvent(c, p, "OnStoppedAdministration"));
        this.CarehomeHub.OnPatientAdministrationChanged((c, p) => this.HandleServerEvent(c, p, "OnPatientAdministrationChanged"));

    }

    public async Initialize(carehomeId: string, wardId: string, marDate: Date): Promise<void> {
        this.IsLoading = true;

        if (carehomeId) {
            console.log("Trying to Initialize Carehome Hub With Id : " + carehomeId);
            this.CarehomeHub.ResetConnection(carehomeId);
        }

        this.Patients = new Array<PatientDto>();
        this.Groups = new Array<MedRoundGroup>();
        this.PatientRounds = new Array<IPatientRound>();

        this._carehomeId = carehomeId;
        this._marDate = marDate;

        if (!this._carehomeId || !this._marDate) {
            return Promise.resolve();
        }

        var dal = new Dal();
        var that = this;

        return dal.GetDispensationPatients(this._marDate, this._carehomeId)
            .then(patientData => {
                this.Patients = patientData.filter(p => p.wardId == wardId || !wardId)
                return this.LoadPatientData(this.Patients );
            })
            .then(() => this.UpdatePatientAdministrationStatus(true))
            .then(() => this.SetActiveGroup())
            .then(() => { this.IsLoading = false });
    }

    public dispose(){
        if (this.CarehomeHub) {
            this.CarehomeHub.Dispose();
        }
    }

    public SetActiveGroup(): void {

        if (!this.IsMarForToday()) {
            this.CurrentGroupIndex = -1;
            return;
        }

        var currentTime = moment();
        this.CurrentGroupIndex = -1;
        this.Groups.forEach((group, index) =>
        {
            if (
                    group.medRoundGroupName.toUpperCase() == "INSULIN"
                ||  group.medRoundGroupName.toUpperCase() == "WARFARIN"
                ||  group.medRoundGroupName.toUpperCase() == "PRN") {
                return;
            }

            var startTime = moment(group.medRoundGroupStartTime, 'hh:mm:ss');
            var endTime = moment(group.medRoundGroupEndTime, 'hh:mm:ss');

            if (currentTime.isSameOrAfter(startTime) && currentTime.isBefore(endTime)) {
                    this.CurrentGroupIndex = index;
            }
        })
    }

    public HandleServerEvent(carehomeId: string, patientId: string, event: string) {

        console.log("***** Handle Server Event ********", carehomeId, patientId, event);
        

        if (!this.Patients || carehomeId != this._carehomeId)
            return;

        if (event == "OnStartedAdministration" || event == "OnStoppedAdministration") {
            this.UpdatePatientAdministrationStatus();
        }

        else if (event == "OnPatientAdministrationChanged") {
            this.UpdateIndividualPatientData(patientId);
        }
    }

    private IsMarForToday(): boolean {

        var now = moment().startOf('day');
        var diff = now.diff(moment(this._marDate), 'day');
        return diff == 0;
    }

    private UpdatePatientAdministrationStatus(isInitializing : boolean = false) {

        if (!this.IsMarForToday()) {

            return;
        }

        var dal = new Dal();

        return dal.GetCarehomeStatus(this._carehomeId).then(data => {
            if (!data.patients)
                return;

            console.log("UpdatePatientAdministrationStatus", data.patients);
            for (var patientRound of this.PatientRounds) {

                var patient = data.patients.find(patient => patientRound.Patient.pharmacyPatientId == patient.id)

                if (patient) {
                     console.log("UpdatePatientAdministrationStatus - Checking Dates", patient.marDate, this._marDate, moment(patient.marDate).diff(this._marDate, 'day') );

                    if (moment(patient.marDate).diff(this._marDate, 'day') == 0 ) {
                        patientRound.IsActive = true;
                        patientRound.Nurse = patient.carer;

                        var toast = patientRound.Patient.firstName + " " + patientRound.Patient.lastName + " by " + patient.carer

                        if (!isInitializing)
                            toastr.Info("Started Administration", toast, { timeOut: "10000", closeButton: false });
                    }
                }
                else {
                    if (patientRound.IsActive) {
                        var toast = patientRound.Patient.firstName + " " + patientRound.Patient.lastName + " by " + patientRound.Nurse
                        toastr.Info("Stopped Administration", toast, { timeOut: "10000", closeButton: false });
                    }

                    patientRound.IsActive = false;
                }
            }
        })
    }

    private LoadPatientData(patientData: Array<PatientDto>): Promise<void> {
        var dal = new Dal();
        var promises = [];
        var patientRounds = new Array<IPatientRound>();

        // Request All Patient Data in parallel
        for (var patient of patientData) {
            promises.push(this.ProcessIndividualPatientData(patient, this._marDate));
        }
        var that = this;
        return Promise.all(promises)
            .then(roundOutput => {
                for (var round of roundOutput)
                    this.PatientRounds.push(round);
            })
    }

    private UpdateIndividualPatientData(pharmacyPatientId: string): Promise<void> {
       
        var dal = new Dal();
        var patient = this.Patients.find(p => p.pharmacyPatientId == pharmacyPatientId);
        console.log("Trying to update patient :", pharmacyPatientId, patient);
        if (!patient) {
            return Promise.resolve();
        }

        var patientRound : any = this.PatientRounds.find(p => p.Patient.pharmacyPatientId == pharmacyPatientId);
        var that = this;

        console.log("Getting dispensation mar", patientRound);
        return dal.GetDispensationMar(that._marDate, pharmacyPatientId)
            .then(data => {
                var patientMar = <IPatientMar>{ Patient: patient, MarData: data }

                console.log("Udpating PAtients1");
                if (patientRound) {
                    console.log("Udpating PAtients");
                    that.ProcessPatientRounds(patientRound, patientMar);
                }
            })
    }

    private ProcessIndividualPatientData(patient: PatientDto, marDate: Date): Promise<IPatientRound> {
        var dal = new Dal();

        var promise = dal.GetDispensationMar(marDate, patient.pharmacyPatientId)
            .then(data => { return { Patient: patient, MarData: data } })
            .then(patientMar => {
                //console.log("PatientMAR : ", patientMar);
                var patientRound = this.PatientRounds.find(p => p.Patient.pharmacyPatientId == patientMar.Patient.pharmacyPatientId);

                // If no patient rounds found - add him to round list
                if (!patientRound) {

                    patientRound = <IPatientRound>{
                        Patient: patientMar.Patient,
                        IsActive: false,
                        Nurse: "",
                        Rounds: {}
                    };
                }

                this.ProcessPatientRounds(patientRound, patientMar);

                return patientRound;
            })

        return promise;

    }

    private ProcessPatientRounds(patientRound: IPatientRound, patientMar: IPatientMar) {

        patientRound.latestMARUser = patientMar.MarData.latestMARUser;
        patientRound.latestMedAdminDateTime = patientMar.MarData.latestMedAdminDateTime;

        for (var group of patientMar.MarData.roundGroups) {
            this.MergeGroup(group)
        }
        for (var group of patientMar.MarData.roundGroups) {

            if (!patientRound.Rounds[group.medRoundGroupName]) {
                patientRound.Rounds[group.medRoundGroupName] = <ITrackingMedRoundGroup>{
                    MedRoundGroup: group,
                    RecentlyChanged: false
                }
            }
            else if (!this.IsRoundEqual(patientRound.Rounds[group.medRoundGroupName].MedRoundGroup, group)) {

                patientRound.Rounds[group.medRoundGroupName].MedRoundGroup = group;
                patientRound.Rounds[group.medRoundGroupName].RecentlyChanged = true;

                toastr.Info("Status Updated", " for " + patientRound.Patient.firstName + " " + patientRound.Patient.lastName, {})
            }
            else {
                patientRound.Rounds[group.medRoundGroupName].RecentlyChanged = false;
            }
        }
    }

    private IsRoundEqual(a: MedRoundGroup, b: MedRoundGroup): boolean {
        return (
            a.missedCount   == b.missedCount &&
            a.pendingCount  == b.pendingCount &&
            a.skipCount     == b.skipCount &&
            a.takenCount    == b.takenCount)

    }

    private MergeGroup(group: MedRoundGroup) {
        if (this.Groups.filter(g => g.medRoundGroupName == group.medRoundGroupName).length == 0) {
            this.Groups.push(group);
        }
    }

}




// WEBPACK FOOTER //
// ./ClientApp/components/pages/carehome-dispensation/CarehomeDispensationController.ts